module.exports = __webpack_public_path__ + "assets/28cc909acb715fec8c50d8dc27fcd430.png";